import React from 'react';
import Button from '@material-ui/core/Button';
import Dialog from '@material-ui/core/Dialog';
import DialogActions from '@material-ui/core/DialogActions';
import DialogContent from '@material-ui/core/DialogContent';
import DialogContentText from '@material-ui/core/DialogContentText';
import { makeStyles } from "@material-ui/core/styles";
import { colors } from "@material-ui/core"
import DialogTitle from '@material-ui/core/DialogTitle';
import Slide from '@material-ui/core/Slide';

const useStyles = makeStyles(theme => ({
  value: {
    fontSize: 14,
    fontWeight: 600,
    color: colors.grey[900],
  },
  formValue: {
    fontSize: 20,
    fontWeight: 600,
    // flex: 1,
    color: colors.grey[900],
    border: 0,
    resize: 'none',
    overflow: 'hidden',
    padding: '-70px',
    backgroundColor: "#F4F6F8",
    maxWidth: '100%'
  },
  MuiTypographyH6: {
    // color: '#263238',
    fontSize: '18px',
    fontFamily: "Roboto",
    fontWeight: 800,
    lineHeight: "20px",
    letterSpacing: "-0.05px",
    color: colors.grey[900],
    backgroundColor: colors.lightBlue[300] 
}
}));

const Transition = React.forwardRef(function Transition(props, ref) {
  return <Slide direction="up" ref={ref} {...props} />;
});

export const AlertDialogSlide = ({handleClose, openSuccess, handleCloseSuccess}) => {
  const classes = useStyles();
  return (
    <div>
      <Dialog
        open={openSuccess}
        TransitionComponent={Transition}
        keepMounted
        onClose={handleCloseSuccess}
        aria-labelledby="alert-dialog-slide-title"
        aria-describedby="alert-dialog-slide-description"
      >
        <DialogTitle className={classes.MuiTypographyH6} id="alert-dialog-slide-title">{"SUCCESS ALERT"}</DialogTitle>
        <DialogContent>
          <DialogContentText id="alert-dialog-slide-description">
          <span className={classes.value}>Suucessful Review! <br/><br/>
            You've succesfully Reviewed the Client KYC information.</span> <br/><br/>
          </DialogContentText>
        </DialogContent>
        <DialogActions>
          {/* <Button onClick={handleCloseSuccess} color="primary">
            Disagree
          </Button> */}
          <Button variant="contained" onClick={()=>{ handleCloseSuccess();}} color="primary">
            Okay
          </Button>
        </DialogActions>
      </Dialog>
    </div>
  )};

export default AlertDialogSlide;